import type { IconSvgObject } from './types';

const InsertTopImageIcon: IconSvgObject = [
  ["path", { d: "M3 17H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 5V11C21 12.1046 20.1046 13 19 13H5C3.89543 13 3 12.1046 3 11V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5Z", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default InsertTopImageIcon;
